module.exports = __webpack_public_path__ + "PB.7e1960b23f7d8f801cdc.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/vanherck/Documents/GitHub/portfolio/src/assets/img/PB.png
// module id = ../../../../../src/assets/img/PB.png
// module chunks = styles